"use client";

import { AnimatePresence } from "motion/react";
import React from "react";
import { splitBreakpointProps } from "@/lib/utils";
import type { AnimatePresenceProps } from "../types";

function Presence({ children, ...props }: AnimatePresenceProps) {
  const { native } = splitBreakpointProps(props);

  return <AnimatePresence {...native}>{children}</AnimatePresence>;
}

Presence.displayName = "Animate.Presence";

export default Presence;
